
































































































import { Component, Vue } from "vue-property-decorator";
import { Rules } from "@ct/validations";
import GET_COMMUNITIES_QUERY from "@/graphql/CommunitiesQuery.gql";
import { GetCommunities_communities } from "@/graphql/generatedTypes/GetCommunities";
import SIGN_UP_MUTATION from "@/graphql/SignUpMutation.gql";
import { SignUpMutation, SignUpMutationVariables } from "@/graphql/generatedTypes/SignUpMutation";
import { AlertBar } from "@ct/alert";
import _ from "lodash";
import { Auth } from "@ct/auth/src/AuthRepository";

interface SignUpResponse {
  signUp: {
    jwt: string;
    currentUser: {
      email: string;
      imgRole: string;
    };
  };
}

@Component({
  components: { AlertBar },
  apollo: {
    communities: GET_COMMUNITIES_QUERY
  },
  metaInfo: {
    title: "Intro To IMS - Sign Up",
    meta: [
      {
        property: "og:title",
        content: "Intro To IMS - Sign Up"
      },
      {
        property: "og:image",
        content: "https://res.cloudinary.com/dm1xkelzx/image/upload/q_auto/v1686607172/IMS_Triangle_hcfwcc.png"
      }
    ]
  }
})
export default class SignUp extends Vue {
  private email = "";
  private firstName = "";
  private lastName = "";
  private phone = "";
  private password = "";
  private passwordConfirmation = "";
  private newsLetterSignedUp = true;
  private communityIds = [];
  private rules = Rules;
  private errors = { email: [], password: [] } as { [key: string]: string[] };

  communities: GetCommunities_communities[] = [];

  private get passwordsMatch() {
    return this.password === this.passwordConfirmation ? "" : "Passwords must match";
  }

  private async signUp() {
    if (!(this.$refs.form as HTMLFormElement).validate()) {
      return;
    }

    const signUpResult = await this.$apollo.mutate<SignUpMutation, SignUpMutationVariables>({
      mutation: SIGN_UP_MUTATION,
      variables: {
        userInput: {
          newsletterSignedUp: this.newsLetterSignedUp,
          firstName: this.firstName,
          lastName: this.lastName,
          email: this.email,
          phone: this.phone,
          password: this.password,
          passwordConfirmation: this.passwordConfirmation,
          communityIds: this.communityIds
        }
      }
    });

    if (signUpResult.data?.signUp) {
      this.errors = signUpResult.data.signUp.errors.reduce((memo, error) => {
        const { path } = error;
        if (!memo[path]) {
          memo[path] = [];
        }

        memo[path].push(error.message);

        return memo;
      }, {} as { [key: string]: string[] });

      if (!_.isEmpty(this.errors)) {
        return;
      }

      this.$authRepository.signIn(signUpResult.data.signUp as Auth);

      if (this.$route.query?.from) {
        await this.$router.push({
          path: this.$route.query.from as string,
          query: { join: this.$route?.query?.join, email: this.$route?.query?.email as string }
        });

        return;
      }

      await this.$router.push({
        name: "users_group_path",
        params: { userId: (signUpResult.data.signUp.currentUser?.id as string) ?? undefined }
      });
      return;
    }
  }

  async navigateToSignInPage() {
    if (this.$route.query?.from) {
      await this.$router.push({
        name: "sign_in_path",
        query: {
          from: this.$route.query.from,
          join: this.$route.query.join,
          email: this.$route?.query?.email
        }
      });
      return;
    } else {
      await this.$router.push({
        name: "sign_in_path"
      });
    }
  }

  get sortedCommunity() {
    return _.sortBy(this.communities, x => (x.name || "").toLowerCase());
  }
}
